// extracted by mini-css-extract-plugin
module.exports = {"formu":"Search_formu__2ebj1","inputButton":"Search_inputButton__38MIL"};